<script>
import warning from "../../assets/images/warning.svg"
import checkGray from "../../assets/images/check-gray.svg"
import checkGreen from "../../assets/images/check-green.svg"

export default {
  name: "KycTab",
  props: {
    index: {
      type: [String, Number],
      required: true
    },
    text: {
      type: String,
      required: true
    },
    active: Boolean,
    status: String,
  },
  data() {
    return {
      warning: warning,
      checkGray: checkGray,
      checkGreen: checkGreen,
    }
  },
  methods: {
    valueSelect() {
      if(this.status !== 'pending'){
        this.$emit('selectTab', this.index)
      }
    }
  }
}
</script>

<template>
<div class="kyc-tab" :class="{
  'active': active
}" @click.prevent="valueSelect">
  <img :src="status === 'current' ? warning : status === 'pending' ? checkGray : status === 'done' ? checkGreen : null " alt="warning" />
  <div class="d-flex align-items-center">
    <span>{{ text }}</span>
  </div>
</div>
</template>

<style scoped lang="scss">
.kyc-tab {
  color: var(--text-primary-color);
  font-size: 14px;
  font-weight: 700;
  height: 50px;
  width: 220px;
  border-bottom-left-radius: 25px;
  border-top-left-radius: 25px;
  background-color: var(--sidebar-background);
  display: flex;
  align-items: center;
  gap: 12px;
  padding-left: 12px;
  opacity: .7;

  &.active {
    opacity: 1;
    color: var(--primary-color-new);
  }
}
</style>